import script from "./EmployeeSOPMainSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeSOPMainSideBar.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeSOPMainSideBar.vue?vue&type=style&index=0&id=abee5318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abee5318"]])

export default __exports__